import { MfeReactComponent } from '@carvana/microfrontend-react';
import useLoadComposerUiMfe from '~/components/composer/useLoadComposerUiMfe';
import { COMPOSER_MODULE } from '~/constants/common/MfeModules';
import useMfeMountGate from '~/hooks/common/mfe/useMfeMountGate';

type OwnProps = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function ComposerUiMfe({ isOpen, onRequestClose }: OwnProps) {
  const canMount = useMfeMountGate(COMPOSER_MODULE);

  useLoadComposerUiMfe();

  if (!canMount) return null;

  return (
    <MfeReactComponent
      component="default"
      isOpen={isOpen}
      module={COMPOSER_MODULE}
      onRequestClose={onRequestClose}
    />
  );
}
